import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { WHAT_IF_URL } from 'src/constants/constants.js';
import WhatIfPres from '../presentational/WhatIfPres';

class WhatIfContainer extends React.Component {
  onGoToCalculator = () => {
    this.props.push(WHAT_IF_URL);
  };

  render() {
    return <WhatIfPres {...this.props} onGoToCalculator={this.onGoToCalculator} />;
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  push,
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfContainer);
